import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { RootState } from '@root/app.state';
import { back } from '@platform/router.actions';

@Component({
  selector: 'app-notfound',
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.scss'],
  standalone: false,
})
export class NotFoundComponent implements OnInit {
  constructor(private store$: Store<RootState>) {}

  ngOnInit(): void {}

  public async navigateBack(): Promise<void> {
    this.store$.dispatch(back());
  }
}
